import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Spin, Alert } from "antd";
import schemesIcon from "../../assets/icons/schemes.png";
import govIcon from "../../assets/icons/gov.png";
import axios from "../../services/axios";
import download from "../../assets/icons/download.svg";
import visit from "../../assets/icons/visit.svg";

// Marathi schemes fallback data
const schemesDataMr = [
  {
    id: 1,
    title: "पीएम आवास योजना",
    tag: "केंद्रीय",
    description:
      "घर बांधकामासाठी आर्थिक सहाय्य प्रदान करणारी सर्वांसाठी गृहनिर्माण योजना.",
    info: [
      { label: "लाभार्थी", value: "२५ कुटुंबे" },
      { label: "पात्रता", value: "गरिबी रेषेखालील कुटुंबे" },
    ],
    links: { gr_download_link: "#", beneficiary_link: "#", website_link: "#" },
  },
  {
    id: 2,
    title: "महाराष्ट्र गृहनिर्माण योजना",
    tag: "राज्य",
    description:
      "महाराष्ट्राची सर्वांसाठी गृहनिर्माण उपक्रम घर बांधकामासाठी आर्थिक सहाय्य देते.",
    info: [
      { label: "पात्र प्राप्तकर्ते", value: "गरजू २५ घरे" },
      { label: "सहभागाचे निकष", value: "गरिबी रेषेखालील कुटुंबे" },
    ],
    links: { gr_download_link: "#", beneficiary_link: "#", website_link: "#" },
  },
  {
    id: 3,
    title: "पीएम आवास योजना - ग्रामीण",
    tag: "केंद्रीय",
    description:
      "भारतातील ग्रामीण भागात पक्की घरे बांधण्यासाठी आर्थिक सहाय्य.",
    info: [
      { label: "लाभार्थी", value: "ग्रामीण कुटुंबे" },
      { label: "पात्रता", value: "अजा/अजजा, गरिबी रेषेखालील कुटुंबे" },
    ],
    links: { gr_download_link: "#", beneficiary_link: "#", website_link: "#" },
  },
  {
    id: 4,
    title: "तमिळनाडू शहरी गृहनिर्माण योजना",
    tag: "राज्य",
    description:
      "शहरी तमिळनाडू भागातील कमी उत्पन्न गटांसाठी परवडणारे घर समर्थन.",
    info: [
      { label: "पात्र प्राप्तकर्ते", value: "कमी उत्पन्न शहरी कुटुंबे" },
      { label: "सहभागाचे निकष", value: "गरिबी रेषेखालील रहिवासी" },
    ],
    links: { gr_download_link: "#", beneficiary_link: "#", website_link: "#" },
  },
  {
    id: 5,
    title: "पीएम किसान आवास योजना",
    tag: "केंद्रीय",
    description:
      "शेतकऱ्यांसाठी विशेष योजना ज्यामध्ये गृहनिर्माण आणि मूलभूत सुविधांचे समर्थन.",
    info: [
      { label: "लाभार्थी", value: "नोंदणीकृत लहान शेतकरी" },
      { label: "पात्रता", value: "२ हेक्टरपेक्षा कमी जमीनधारक" },
    ],
    links: { gr_download_link: "#", beneficiary_link: "#", website_link: "#" },
  },
  {
    id: 6,
    title: "केरळ गृहनिर्माण सहाय्य योजना",
    tag: "राज्य",
    description:
      "केरळमधील पूरग्रस्त घरांच्या पुनर्बांधणी आणि नूतनीकरणासाठी आर्थिक मदत.",
    info: [
      { label: "पात्र प्राप्तकर्ते", value: "पूरग्रस्त कुटुंबे" },
      {
        label: "सहभागाचे निकष",
        value: "राज्य प्राधिकरणाद्वारे सत्यापित रहिवासी",
      },
    ],
    links: { gr_download_link: "#", beneficiary_link: "#", website_link: "#" },
  },
  {
    id: 7,
    title: "पीएम आवास योजना (शहरी)",
    tag: "केंद्रीय",
    description:
      "शहरी झोपडपट्टी पुनर्वसन आणि विकासासाठी परवडणारी गृहनिर्माण उपक्रम.",
    info: [
      { label: "लाभार्थी", value: "शहरी गरीब आणि झोपडपट्टी रहिवासी" },
      { label: "पात्रता", value: "ईडब्ल्यूएस, एलआयजी आणि एमआयजी श्रेणी" },
    ],
    links: { gr_download_link: "#", beneficiary_link: "#", website_link: "#" },
  },
  {
    id: 8,
    title: "राजस्थान ग्रामीण गृहनिर्माण मिशन",
    tag: "राज्य",
    description:
      "मूलभूत सुविधांसह पक्की घरे प्रदान करून ग्रामीण समुदायांना सक्षम करते.",
    info: [
      { label: "पात्र प्राप्तकर्ते", value: "ग्रामीण गरिबी रेषेखालील कुटुंबे" },
      {
        label: "सहभागाचे निकष",
        value: "ग्राम पंचायतींद्वारे ओळखले गेलेले",
      },
    ],
    links: { gr_download_link: "#", beneficiary_link: "#", website_link: "#" },
  },
  {
    id: 9,
    title: "ओडिशा हरित गृहनिर्माण योजना",
    tag: "राज्य",
    description:
      "टिकाऊ बांधकाम साहित्यासह पर्यावरण-अनुकूल घरांना प्रोत्साहन.",
    info: [
      { label: "पात्र प्राप्तकर्ते", value: "आर्थिकदृष्ट्या कमकुवत कुटुंबे" },
      { label: "सहभागाचे निकष", value: "गरिबी रेषेखालील कार्डधारक" },
    ],
    links: { gr_download_link: "#", beneficiary_link: "#", website_link: "#" },
  },
];

// English schemes fallback data
const schemesDataEn = [
  {
    id: 1,
    title: "PM Awas Yojana",
    tag: "Central",
    description:
      "Housing for All scheme providing financial assistance for house construction.",
    info: [
      { label: "Beneficiaries", value: "25 Families" },
      { label: "Eligibility", value: "Below Poverty Line families" },
    ],
    links: { gr_download_link: "#", beneficiary_link: "#", website_link: "#" },
  },
  {
    id: 2,
    title: "Maharashtra Housing Scheme",
    tag: "State",
    description:
      "Maharashtra's Housing for All initiative provides financial assistance for house construction.",
    info: [
      { label: "Eligible Recipients", value: "25 needy homes" },
      { label: "Participation Criteria", value: "Below Poverty Line families" },
    ],
    links: { gr_download_link: "#", beneficiary_link: "#", website_link: "#" },
  },
  {
    id: 3,
    title: "PM Awas Yojana - Rural",
    tag: "Central",
    description:
      "Financial assistance to build pucca houses in rural areas of India.",
    info: [
      { label: "Beneficiaries", value: "Rural families" },
      { label: "Eligibility", value: "SC/ST, Below Poverty Line families" },
    ],
    links: { gr_download_link: "#", beneficiary_link: "#", website_link: "#" },
  },
  {
    id: 4,
    title: "Tamil Nadu Urban Housing Scheme",
    tag: "State",
    description:
      "Affordable housing support for low income groups in urban Tamil Nadu areas.",
    info: [
      { label: "Eligible Recipients", value: "Low income urban families" },
      { label: "Participation Criteria", value: "Below Poverty Line residents" },
    ],
    links: { gr_download_link: "#", beneficiary_link: "#", website_link: "#" },
  },
  {
    id: 5,
    title: "PM Kisan Awas Yojana",
    tag: "Central",
    description:
      "Special scheme for farmers with housing and basic amenities support.",
    info: [
      { label: "Beneficiaries", value: "Registered small farmers" },
      { label: "Eligibility", value: "Land holders less than 2 hectares" },
    ],
    links: { gr_download_link: "#", beneficiary_link: "#", website_link: "#" },
  },
  {
    id: 6,
    title: "Kerala Housing Assistance Scheme",
    tag: "State",
    description:
      "Financial aid for reconstruction and renovation of flood-affected houses in Kerala.",
    info: [
      { label: "Eligible Recipients", value: "Flood-affected families" },
      {
        label: "Participation Criteria",
        value: "Residents verified by state authority",
      },
    ],
    links: { gr_download_link: "#", beneficiary_link: "#", website_link: "#" },
  },
  {
    id: 7,
    title: "PM Awas Yojana (Urban)",
    tag: "Central",
    description:
      "Affordable housing initiative for urban slum rehabilitation and development.",
    info: [
      { label: "Beneficiaries", value: "Urban poor and slum dwellers" },
      { label: "Eligibility", value: "EWS, LIG and MIG categories" },
    ],
    links: { gr_download_link: "#", beneficiary_link: "#", website_link: "#" },
  },
  {
    id: 8,
    title: "Rajasthan Rural Housing Mission",
    tag: "State",
    description:
      "Empowers rural communities by providing pucca houses with basic amenities.",
    info: [
      { label: "Eligible Recipients", value: "Rural BPL families" },
      {
        label: "Participation Criteria",
        value: "Identified by Gram Panchayats",
      },
    ],
    links: { gr_download_link: "#", beneficiary_link: "#", website_link: "#" },
  },
  {
    id: 9,
    title: "Odisha Green Housing Scheme",
    tag: "State",
    description:
      "Promotes eco-friendly homes with sustainable construction materials.",
    info: [
      { label: "Eligible Recipients", value: "Economically weaker families" },
      { label: "Participation Criteria", value: "BPL card holders" },
    ],
    links: { gr_download_link: "#", beneficiary_link: "#", website_link: "#" },
  },
];

const SchemeCard = ({ title, tag, description, info = [], links = {}, t, isBenificiary = true }) => {
  const {
    gr_download_link,
    beneficiary_link,
    website_link,
  } = links;

  const CustomButton = ({ href, label, icon }) => {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={`flex items-center sm:justify-center gap-2 text-[13px] sm:text-[14px] w-full sm:w-[150px] h-[40px] rounded-md transition-all`}
      >
        {icon && <img loading="lazy" src={icon} alt="" className="w-4 h-4" />}
        <span className="text-[var(--color-primary)]">{label}</span>
      </a>
    );
  };

  return (
    <div className="bg-white border rounded-md p-4 flex flex-col justify-between gap-4 h-full">
      <div className="flex flex-col gap-3">
        {/* Header */}
        <div className="flex justify-between items-start">
          <h1 className="text-base md:text-lg font-semibold text-[#212121] m-0">
            {title}
          </h1>
          <p
            className={`${tag?.toString().toLowerCase() === "central" || tag === "केंद्रीय"
              ? "bg-[#FFEEEA]"
              : "bg-[#FAEFFF]"
              } rounded-lg px-3 py-1 text-sm text-[#212121] m-0`}
          >
            {tag}
          </p>
        </div>

        {/* Description */}
        <p className="text-sm text-[#212121] m-0">
          {description}
        </p>
        {/* Info */}
        <div className="grid grid-cols-1 gap-1">
          {info.map((item, idx) => (
            <div key={idx} className="flex flex-col gap-2">
              <h2 className="text-base md:text-lg font-medium text-[#212121] m-0">
                {item.label}
              </h2>
              <p className="text-sm text-[#212121] m-0">{item.value}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="flex flex-col gap-2">
        {/* --- Buttons Section --- */}
        <div className="w-full flex gap-2 max-[400px]:flex-col">
          <CustomButton
            href={gr_download_link}
            label={t("Download GR") || "Download GR"}
            icon={download}
          />

          {isBenificiary && (
            <CustomButton
              href={beneficiary_link}
              label={t("Beneficiaries") || "Beneficiaries"}
              icon={download}
              outline
            />
          )}
        </div>

        {/* Row 2: Website + Apply */}
        <div className="flex flex-col sm:gap-3 gap-2 w-full sm:justify-between">
          <a
            href={website_link}
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm flex items-center justify-center gap-2 text-[var(--color-primary)] border border-[var(--color-primary)] rounded-md h-[40px] hover:bg-[#EAF8E3] transition-all w-full"
          >
            <img loading="lazy" src={visit} alt="" className="w-4 h-4" />
            {t("Visit Main Website") || "Visit Main Website"}
          </a>

          {/* <a
              href={apply_link}
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm flex items-center justify-center bg-[var(--color-primary)] text-white rounded-md h-[40px] px-4 hover:bg-[var(--color-primary-dark)] transition-all w-full"
            >
              {t("Apply") || "Apply"}
            </a> */}

        </div>
      </div>
    </div>
  );
};

const Schemes = () => {
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [remoteSchemes, setRemoteSchemes] = useState(null);

  useEffect(() => {
    let mounted = true;
    const languageParam = i18n.language === "mr" ? "Marathi" : "English";
    setLoading(true);
    setError(null);

    axios
      .get("/schemes/", { params: { language: languageParam } })
      .then((resp) => {
        const data = Array.isArray(resp.data)
          ? resp.data
          : resp.data.results || resp.data.data || Object.values(resp.data || {});
        if (!mounted) return;

        if (Array.isArray(data) && data.length > 0) {
          const mapped = data.map((s) => ({
            id: s.id,
            title: s.title,
            tag: s.level || (i18n.language === "mr" ? "राज्य" : "State"),
            description: s.description || s.data_top || "",
            info: [
              {
                label:
                  s.data_top ||
                  s.value_top ||
                  (i18n.language === "mr" ? "माहिती" : "Info"),
                value: s.value_top || "",
              },
              { label: s.data_bottom || s.value_bottom || "", value: s.value_bottom || "" },
            ],
            links: {
              gr_download_link: s.gr_download_link,
              beneficiary_link: s.beneficiary_link,
              website_link: s.website_link,
              apply_link: s.apply_link,
            },
          }));
          setRemoteSchemes(mapped);
        } else {
          setRemoteSchemes(null);
        }
      })
      .catch((err) => {
        if (mounted) setError(err.message || "Failed to load schemes");
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });

    return () => {
      mounted = false;
    };
  }, [i18n.language]);

  // Use API data if available, otherwise fallback to static data
  const fallbackData = i18n.language === "mr" ? schemesDataMr : schemesDataEn;
  const schemes = remoteSchemes || fallbackData;

  return (
    <div id="schemes" className="border bg-white rounded-md p-4 flex flex-col gap-3">
      <div className="flex gap-3 items-center">
        <img loading="lazy" src={schemesIcon} alt="Schemes Icon" className="w-10 h-10" />
        <h2 className="font-semibold m-0 text-2xl max-sm:text-xl">{t("Schemes") || "योजना"}</h2>
      </div>

      <p className="text-base text-[#212121]">
        {t(
          "Explore our ongoing development initiatives, completed projects, and government schemes designed to improve rural infrastructure and community welfare."
        )}
      </p>

      <div className="flex flex-col border rounded-md bg-[#FDF2F5] p-4">
        <div className="flex gap-2 items-center mb-3">
          <img loading="lazy" src={govIcon} alt="Government Icon" className="w-5 h-5" />
          <h4 className="text-xl font-semibold text-md m-0">
            {t("Government Schemes") || "सरकारी योजना"}
          </h4>
        </div>

        {loading && (
          <div className="py-4 flex justify-center">
            <Spin />
          </div>
        )}

        {error && (
          <div className="py-4">
            <Alert
              type="error"
              message={t("Failed to load schemes")}
              description={error}
            />
          </div>
        )}

        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
          {schemes.map((scheme, idx) => (
            <SchemeCard
              key={scheme.id}
              title={scheme.title}
              tag={scheme.tag}
              description={scheme.description}
              info={scheme.info}
              links={scheme.links}
              t={t}
              isBenificiary={idx !== 0}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Schemes;
